import SearchProvider from '../data/schema/SearchProvider';

export type SubstrateSearchApiVersion = 1 | 2 | 3;

export default function getSubstrateSearchApiVersion(
    searchProvider: SearchProvider
): SubstrateSearchApiVersion | undefined {
    switch (searchProvider) {
        case SearchProvider.Substrate:
            return 1;
        case SearchProvider.SubstrateV2:
            return 2;
        case SearchProvider.SubstrateV3:
            return 3;
        default:
            return undefined;
    }
}
